// const BASE_URL = "https://localhost:7231/api/Section";


import { BASE_URL } from "../config";

// /api/Section/sections
export const getAllSection = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Section/sections`);
    if (!response.ok) {
      throw new Error("Failed to fetch sections");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching sections:", error);
    throw error;
  }
};


export const updateSection = async (id, section) => {
  try {
    const response = await fetch(`${BASE_URL}/Section/sections/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sectionID: id,
        sectionName: section.sectionName,
        sectionDescription: section.sectionDescription || "",
        departmentID: section.departmentID, // required for backend
        trUser: sessionStorage.getItem("username") || "admin",
        trDate: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to update section");
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating section:", error);
    throw error;
  }
};



export const addSection = async (section) => {
  try {
    const response = await fetch(`${BASE_URL}/Section/sections`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sectionName: section.sectionName,
        departmentID: section.departmentID,
        sectionDescription: section.sectionDescription || null,
        crUser: sessionStorage.getItem("username") || "admin",
        crDate: new Date().toISOString(),
        deleted: "N",
      }),
    });

    if (response.status !== 201) {
      throw new Error("Failed to create section");
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating section:", error);
    throw error;
  }
};


export const deleteSection = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/Section/sections/${id}`, {
      method: "DELETE",
    });

    if (response.status !== 204) {
      throw new Error("Failed to delete section");
    }

    return true; // success
  } catch (error) {
    console.error("Error deleting section:", error);
    throw error;
  }
};
